<template>
<div class="winnersMoreOffTxtBG">
    <h2 class="winnersMoreOffTxt">Earn FREE Site Credit or Raffolux Points when you send in a winner photo!</h2>
</div>
<!-- carousel section ends -->
<div class="review-sec">
    <span class="d-flex align-items-center justify-content-center">
        <a href="https://www.trustpilot.com/review/raffolux.com">
            <img :src="socialImgUrlLink + 'redev_images/raffleNewTrustImg.svg'" alt="" class="trustPilot_img" />
            <img :src="socialImgUrlLink + 'redev_images/raffleNewTrustImg.svg'" alt="" class="trustPilot_img_mob" />
        </a>
        <a href="https://www.trustpilot.com/review/raffolux.com">
            <button type="button" class="btn review-btn">Our reviews</button>
        </a>

    </span>
</div>

<div class="mb-prize-pdng">
    <div class="d-flex justify-content-center align-items-center winnerHdr">
        <i class="fas fa-list"></i>
        <h3 class="list-txt mb-0">Winner List</h3>
    </div>
    <ul class="nav nav-pills  justify-content-center align-items-center month-tabs" id="pills-tab" role="tablist">

        <li class="nav-item" role="presentation" v-for="(month, index) in winnersMonthDetails.monthsSet" :key="month">
            <button class="nav-link" :class="{ active: index === activeMonthIndex }" :id="'pills-' + month.month + '-tab'" :data-bs-target="'#pills-' + month.month" type="button" role="tab" :aria-controls="'pills-' + month.month" :aria-selected="index === activeMonthIndex" @click="changeActiveMonth(index)">
                {{ convert_monthname(month.month) }}
            </button>
        </li>

    </ul>

    <div class="input-group search-sec">
        <div class="input-group">
            <div class="input-group-text searchIcon-dsgn">
                <i class="fas fa-search search-icon"></i>
            </div>

            <input type="text" class="form-control search-inp-dsgn" id="inlineFormInputGroup" placeholder="Search by prize" v-model="searchValue" @input="handleInput" />

        </div>
        <div v-if="showDropdown" class="search-results">
            <template v-if="filteredData.length === 1 && filteredData[0].Name === 'Your search was not found. Please try again.'">
                <div class="row justify-content-around m-0">
                    <div class="col-md-10 col-8 p-0">
                        <h3 class="search_txt mb-0">{{ filteredData[0].Name }}</h3>
                    </div>
                </div>
            </template>
            <template v-else>
                <div v-for="item in filteredData" :key="item.id" @click="selectItem(item)" class="row justify-content-around m-0">
                    <div class="col-md-10 col-8 p-0">
                        <h3 class="search_txt mb-0">{{ item.Name }} — {{ item.daysLeft }} days left — {{ item.Title }}</h3>
                    </div>
                    <div class="col-md-2 col-4 text-end p-0">
                        <button @click="goToDrawDetails(item)" class="draw_btn">Draw Details</button>
                    </div>
                </div>
            </template>
        </div>

    </div>

    <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="pills-mar" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
            <div class="mb-3">
                <h2 class="month-hdr month-sec">{{ currentMonth() }}</h2>
                <p v-if="noErrorData" class="error-msg  month-sec">
                    {{ error }}
                </p>

            </div>
            <div class="month-sec" v-for="dayDetails in winnersDatewiseData" :key="dayDetails.date">
                <h5 class="date-txt">{{ formatDate(dayDetails.date) }}</h5>
                <ul class="prize-item p-0 mb-0">
                    <li class="prize-list" v-for="winner in dayDetails.data" :key="winner.id">
                        <div class="row desk-content">
                            <div class="col-md-3">
                                <img :src="`${urlLink}${winner.MiniImageUrl}`" alt="" class="prize-img" />
                            </div>
                            <div class="col-md-9">
                                <h3 class="prize-hdrTxt">
                                    {{ winner.Title }}
                                </h3>
                                <h5 class="prize-subTxt">
                                    Congratulations {{ formatName(winner.Name) }} with winning ticket number
                                    {{ winner.TicketNo }}
                                </h5>
                                <button type="button" @click="goToDrawDetails(winner)" class="btn prize-draw-btn">
                                    <!-- <i class="fas fa-file-alt"></i> -->
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImg.svg" class="drawImgLightDraw" alt="">
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImgDarkTheme.svg" class="drawImgDarkDraw" alt="">
                                    Draw
                                </button>
                            </div>
                        </div>
                        <div class="row mb-content">
                            <div class="col-3">
                                <img :src="`${urlLink}${winner.MiniImageUrl}`" alt="" class="prize-img" />
                            </div>
                            <div class="col-6">
                                <h3 class="prize-hdrTxt">
                                    {{ winner.Title }}
                                </h3>
                                <h5 class="prize-subTxt">
                                    Congratulations {{ formatName(winner.Name) }} with winning ticket number
                                    {{ winner.TicketNo }}
                                </h5>
                            </div>
                            <div class="col-3 p-0 d-flex align-items-center">
                                <button type="button" @click="goToDrawDetails(winner)" class="btn prize-draw-btn">
                                    <!-- <i class="fas fa-file-alt"></i> -->
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImg.svg" class="drawImgLightDraw" alt="">
                                    <img src="https://static.raffolux.com/static/website/redev_images/winnersFileImgDarkTheme.svg" class="drawImgDarkDraw" alt="">
                                    Draw
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import {
    urlLink,
    socialImgUrlLink
} from '@/s3bucket.js';
import {
    apiURL
} from "@/api/allApis"

import "@/assets/css/winnerPage.css";
import moment from "moment";
export default {
    data: () => ({

        winnersMonthDetails: [],
        winnersMonthwiseDetails: [],
        urlLink: urlLink,
        socialImgUrlLink: socialImgUrlLink,
        winnersDatewiseData: [],
        searchValue: "",
        winnersDatewiseDataFilter: [],
        showDropdown: false,
        activeMonthIndex: 0,
        monthName: "",
        day: null,
        error: "No data found for this month",
        noErrorData: false
    }),

    created() {
        this.fetch_winnersMonth()
    },
    watch: {
        searchValue(newValue) {
            this.fetch_WinnersDatewiseDataFilter(newValue);
        },
        winnersMonthDetails: {
            handler(newVal) {
                if (newVal && newVal.monthsSet) {
                    // Call the method to fetch data for the first month
                    this.fetch_WinnersDatewiseData(
                        newVal.monthsSet[this.activeMonthIndex]
                    );
                }
            },
            deep: true,
        },
    },
    computed: {
        filteredData() {
            const currentDate = new Date();
            const filteredResults = this.winnersDatewiseDataFilter
                .flatMap((item) => item)
                .map((item) => {
                    const createdDate = new Date(item.created_at);
                    const daysLeft = Math.floor(
                        (currentDate - createdDate) / (1000 * 60 * 60 * 24)
                    );
                    return {
                        ...item,
                        daysLeft: daysLeft,
                    };
                })
                .filter((item) => {
                    return (
                        item.Name.toLowerCase().includes(this.searchValue.toLowerCase()) ||
                        item.daysLeft.toString().includes(this.searchValue.toLowerCase()) ||
                        item.Title.toLowerCase().includes(this.searchValue.toLowerCase())
                    );
                });

            if (filteredResults.length === 0) {
                return [{
                    Name: 'Your search was not found. Please try again.',
                    daysLeft: '',
                    Title: ''
                }];
            }

            return filteredResults;
        },
    },

    methods: {
        // changeActiveMonth(index) {
        //     alert(1)
        //     this.day = "";
        //     this.activeMonthIndex = index;
        //     this.fetch_WinnersDatewiseData(
        //         this.winnersMonthDetails.monthsSet[index]
        //     );
        // },
        formatName(nameString) {
            const [firstName, lastName] = nameString.split(" ");
            const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
            const formattedLastNameInitial = lastName ? ` ${lastName.charAt(0).toUpperCase()}` : "";

            return `${formattedFirstName}${formattedLastNameInitial}`;
        },
        convert_monthname(val) {
            const monthNames = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ];
            const monthIndex = monthNames.findIndex((month) =>
                val.toLowerCase().includes(month.toLowerCase())
            );
            return monthNames[monthIndex];
        },
        goToDrawDetails(item) {
            this.$router.push({
                name: 'drawDetailsWithoutLogin',
                params: {
                    drawCode: item.DrawCode
                }
            });
        },

        changeActiveMonth(index) {
            this.day = null
            this.noErrorData = false;
            this.activeMonthIndex = index;
            this.fetch_WinnersDatewiseData(this.winnersMonthDetails.monthsSet[index]);
        },
        formatDate(day) {
            const formattedDate = moment(`${this.monthName.year}-${this.monthName.month}-${day}`, "YYYY-MMMM-D").format("dddd Do MMMM");
            return formattedDate;
        },
        currentMonth() {
            const formattedMonth = moment(this.monthName.month, "MMMM").format("MMMM");
            const uppercaseMonth = formattedMonth.toUpperCase();
            return `${uppercaseMonth} ${this.monthName.year}`;
        },

        handleInput() {
            if (this.searchValue.length > 0) {
                this.showDropdown = true;
            } else {
                this.showDropdown = false;
            }
        },
        selectItem(item) {
            this.searchValue = "";
            this.showDropdown = false;
        },
        async fetch_winnersMonth() {
            fetch(apiURL.winnersMonthWithoutLogin, {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",

                    },
                })
                .then((response) => response.json())
                .then((data) => {
                    this.winnersMonthDetails = data;
                    // console.log("winnersMonthDetails", this.winnersMonthDetails);
                    //this.fetch_WinnersMonthwiseData(this.winnersMonthDetails);
                });
        },
        async fetch_WinnersDatewiseData(month) {

            this.monthName = month;
            //console.log("this.monthName",this.monthName)
            const activeMonthIndex = this.activeMonthIndex;
            fetch(apiURL.winnersDatewiseDataWithoutLogin, {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                    },
                    body: JSON.stringify({
                        monthCode: month.monthCode,
                        year: month.year,
                    }),
                })
                .then((response) => response.json())
                .then((data) => {
                    if (this.activeMonthIndex === activeMonthIndex) {
                        this.winnersDatewiseData = data;
                        this.day = null;
                       
                        if (this.winnersDatewiseData.length === 0) {
                            this.noErrorData = true
                        }

                    }

                });
        },

        async fetch_WinnersDatewiseDataFilter(searchValue) {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1;
            const currentYear = currentDate.getFullYear();
            fetch(
                    apiURL.winnersDatewiseDataFilterWithoutLogin, {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json; charset=UTF-8",

                        },
                        body: JSON.stringify({
                            // monthCode: currentMonth,
                            // year: currentYear,
                            searchValue: searchValue,
                        }),
                    }
                )
                .then((response) => response.json())
                .then((data) => {
                    this.winnersDatewiseDataFilter = data;
                    //console.log("winnersDatewiseDataFilter",this.winnersDatewiseDataFilter)
                });
        },
    },
};
</script>

<style>
.search-results {
    list-style-type: none;
    padding: 0;
    margin: 0;
    border: 1px solid #ccc;
    border-top: none;
}

.search-results li {
    padding: 10px;
    cursor: pointer;
    background-color: #f9f9f9;
}

.search-results li:hover {
    background-color: #e9e9e9;
}
</style>
